import Cookies from 'js-cookie';

const AUTH_COOKIE_PREFIXES = ['CognitoIdentityServiceProvider', 'aws-cognito-origin'];

const getParentCookieDomain = () => {
  if (process.env.REACT_APP_COOKIE_DOMAIN) {
    return process.env.REACT_APP_COOKIE_DOMAIN;
  }
  return window.location.hostname.split('.').slice(-2).join('.');
};

const isAuthCookie = (name) => AUTH_COOKIE_PREFIXES.some((prefix) => name.includes(prefix));

/**
 * Clears legacy parent-domain Cognito cookies used by the old cross-app SSO approach.
 * Removes matching cookies for both the current host and the parent cookie domain.
 */
export function clearLegacySsoCookies() {
  const cookies = Cookies.get();
  const authCookieNames = Object.keys(cookies).filter(isAuthCookie);
  const parentDomain = getParentCookieDomain();

  authCookieNames.forEach((name) => {
    Cookies.remove(name);
    Cookies.remove(name, { path: '/' });
    Cookies.remove(name, { path: '/', domain: parentDomain });
    // Leading-dot domain form used by some browsers / older CookieStorage configs
    if (!parentDomain.startsWith('.')) {
      Cookies.remove(name, { path: '/', domain: `.${parentDomain}` });
    }
  });
}

export default clearLegacySsoCookies;
